/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import * as React from "react";
import type { SVGIconProps } from "../../svgIconProps";
import { IconSize } from "../../iconTypes";
import { SVGIconContainer } from "../../svgIconContainer";

export const SearchFilled: React.FC<SVGIconProps> = React.forwardRef<any, SVGIconProps>(({size = IconSize.STANDARD, ...props}, ref) => {
    const isLarge = size! >= IconSize.LARGE;
    const pixelGridSize = isLarge ? IconSize.LARGE : IconSize.STANDARD;
    const translation = `${-1 * pixelGridSize / 0.014705882352941176 / 2}`;
    const style = { transformOrigin: "center" };
    return (
        <SVGIconContainer iconName="search-filled" ref={ref} size={size} {...props}>
            <path
                d={isLarge ? "M566.6666666666666 1246.6666666666667A453.3333333333333 453.3333333333333 0 0 0 913.4666666666666 501.33C938.2300000000002 493.0566666666666 961.0666666666668 479.0599999999999 979.9366666666666 460.1899999999999L1230.0633333333333 210.0633333333335L1149.9366666666665 129.9366666666667L899.81 380.0633333333334C873.1766666666666 406.6966666666667 819.0033333333332 409.36 786.3066666666666 396.6666666666668A453.3333333333333 453.3333333333333 0 1 0 566.6666666666666 1246.6666666666667zM566.6666666666666 1020A226.6666666666667 226.6666666666667 0 0 0 793.3333333333333 793.3333333333334H906.6666666666666A340.0000000000001 340.0000000000001 0 0 1 566.6666666666666 1133.3333333333333V1020z" : "M453.3333333333334 997.3333333333334A362.6666666666667 362.6666666666667 0 0 0 730.7733333333334 401.064C750.5840000000002 394.4453333333332 768.8533333333335 383.248 783.9493333333334 368.152L984.0506666666668 168.0506666666667L919.9493333333334 103.9493333333332L719.8480000000001 304.0506666666667C698.5413333333333 325.3573333333333 655.2026666666667 327.488 629.0453333333334 317.3333333333333A362.6666666666667 362.6666666666667 0 1 0 453.3333333333334 997.3333333333334zM453.3333333333334 816A181.3333333333334 181.3333333333334 0 0 0 634.6666666666667 634.6666666666666H725.3333333333334A272 272 0 0 1 453.3333333333334 906.6666666666666V816z"}
                fillRule="evenodd"
                transform={`scale(0.014705882352941176, -0.014705882352941176) translate(${translation}, ${translation})`}
                style={style}
            />
        </SVGIconContainer>
   );
});
SearchFilled.displayName = `Blueprint5.Icon.SearchFilled`;
export default SearchFilled;
